import { render, staticRenderFns } from "./MiddleForSharingView.vue?vue&type=template&id=55fa10d2&scoped=true"
import script from "./MiddleForSharingView.vue?vue&type=script&lang=js"
export * from "./MiddleForSharingView.vue?vue&type=script&lang=js"
import style0 from "./MiddleForSharingView.vue?vue&type=style&index=0&id=55fa10d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fa10d2",
  null
  
)

export default component.exports